export default __webpack_public_path__ + "static/media/H0003.244db32b.png";